export const messageTemplates = {
    mother: {
        name: 'أمي الحبيبة',
        getOpeningMessage: (count) => `إلى أغلى إنسانة في حياتي، أمي الحبيبة. رمضان كريم، وكل عام وأنتِ بألف خير. هذه ${count} رسالة حب من قلبي لقلبك ❤️`,
        messages: [
            'يا أمي، أنتِ نور حياتي وسر سعادتي. كل يوم معك هو هدية من الله',
            'دعواتك يا أمي هي سر نجاحي. بارك الله فيكِ وحفظك لي',
            'أمي، حضنك هو الأمان، وصوتك هو السكينة، وابتسامتك هي الحياة',
            'كل ما أنا عليه اليوم هو بفضل تربيتك وحبك يا أمي',
            'يا أمي، الجنة تحت قدميك، وأنا أدعو الله أن أكون عند حسن ظنك',
            'أمي، أنتِ القلب الذي لا يتوقف عن الحب، والعطاء الذي لا ينتهي',
            'في كل صلاة أدعو لك يا أمي، أن يحفظك الله ويطيل في عمرك',
            'أمي، تعبك وسهرك من أجلي لن أنساهم أبداً. جزاك الله خيراً',
            'يا أمي، كلماتك الحنونة تشفي جروحي وتطمئن قلبي',
            'أمي، أنتِ الشمعة التي تضيء حياتي بالحب والحنان',
            'في رمضان وكل الأيام، أنتِ دعواتي الأولى يا أمي',
            'أمي، بسمتك تسعدني، ورضاك يريحني، ودعاؤك يحميني',
            'يا أمي، أشتاق لحضنك حتى وأنا بجانبك',
            'أمي، أنتِ معنى التضحية والعطاء بلا حدود',
            'كل نجاح أحققه هو ثمرة دعواتك يا أمي الغالية',
            'أمي، في قلبي مكان لا يملؤه سواكِ',
            'يا أمي، أنتِ السبب الذي يجعلني أستمر وأتقدم',
            'أمي، صبرك علي وتحملك لي هو أعظم درس تعلمته في الحياة',
            'في كل لحظة ضعف، أتذكر قوتك يا أمي فأصبح قوياً',
            'أمي، حبك لي غير مشروط، وهذا أعظم نعمة في حياتي',
            'يا أمي، أدعو الله أن يجعلني سبب سعادتك في الدنيا والآخرة',
            'أمي، أنتِ الأمان الذي أركن إليه عندما تضيق بي الدنيا',
            'في رمضان، أدعو الله أن يرزقك الصحة والعافية يا أمي',
            'أمي، ابتسامتك هي أجمل منظر تقع عليه عيناي',
            'يا أمي، أنتِ المعلمة الأولى التي علمتني معنى الحب الحقيقي',
            'أمي، كل كلمة شكر في الدنيا لن توفيك حقك',
            'في كل سجدة أدعو لك يا أمي، أن يسعدك الله كما أسعدتني',
            'أمي، أنتِ الهدية التي منحني الله إياها',
            'يا أمي، وجودك في حياتي هو أعظم نعمة أحمد الله عليها',
            'أمي، أحبك حباً لا يوصف، وأدعو الله أن يجمعني بك في الجنة ❤️'
        ]
    },

    father: {
        name: 'أبي الغالي',
        getOpeningMessage: (count) => `إلى قدوتي في الحياة، أبي الغالي. رمضان كريم، وكل عام وأنت بخير وصحة. ${count} رسالة من القلب لأعظم رجل في حياتي`,
        messages: [
            'أبي، أنت المثل الأعلى والقدوة التي أسير على خطاها',
            'يا أبي، تعبك وكدك من أجلنا لن أنساه طوال حياتي',
            'أبي، كلماتك الحكيمة هي البوصلة التي توجهني في الحياة',
            'أنت علمتني معنى الرجولة والمسؤولية يا أبي',
            'أبي، دعواتك لي هي سر توفيقي في كل خطوة',
            'يا أبي، أنت السند القوي الذي أستند عليه دائماً',
            'أبي، صبرك وقوتك يلهماني كل يوم',
            'أدعو الله أن يحفظك ويطيل في عمرك يا أبي',
            'أبي، أنت البطل الذي لا يرتدي عباءة',
            'يا أبي، نصائحك الذهبية هي كنوز أحتفظ بها في قلبي',
            'أبي، أنت من علمني أن النجاح يحتاج صبر وعمل',
            'في رمضان وكل الأيام، أنت في قلبي ودعواتي يا أبي',
            'أبي، قوتك في مواجهة الصعاب تعطيني القوة',
            'يا أبي، أنت الشجرة التي نستظل بظلها',
            'أبي، فخور أني ابنك وأحمل اسمك',
            'كل ما أملكه اليوم هو بفضل تعبك يا أبي',
            'أبي، أنت من علمني معنى الكرامة والشرف',
            'يا أبي، ضحكتك تملأ البيت فرحاً وسعادة',
            'أبي، وجودك في حياتي يعطيني الثقة والأمان',
            'أدعو الله أن أكون ابناً باراً عند حسن ظنك يا أبي',
            'أبي، أنت الحكيم الذي أرجع إليه عند كل حيرة',
            'يا أبي، كلمة واحدة منك تكفي لتصحح مساري',
            'أبي، أنت المدرسة التي تعلمت منها أهم دروس الحياة',
            'في رمضان أدعو الله أن يبارك في صحتك وعمرك',
            'أبي، ابتسامتك ورضاك عني هما هدفي في الحياة',
            'يا أبي، أنت القلب الكبير والعقل الحكيم',
            'أبي، شكراً لكل لحظة وقفت فيها بجانبي',
            'أنت لم تكن مجرد أب، بل كنت صديقاً وأخاً ومعلماً',
            'أبي، أحبك حباً يفوق الوصف',
            'أدعو الله أن يجمعني بك في الفردوس الأعلى يا أبي ❤️'
        ]
    },

    spouse: {
        name: 'شريك/ة حياتي',
        getOpeningMessage: (count) => `إلى نصفي الآخر، شريك حياتي وسعادتي. رمضان كريم، وكل عام وأنت بخير. ${count} رسالة حب لأجملهم`,
        messages: [
            'أنت السبب في ابتسامتي كل صباح',
            'معك الحياة أجمل والأيام أحلى',
            'أحمد الله كل يوم أنه اختارك لي',
            'أنت السكن والراحة والسعادة',
            'بجانبك أشعر أني في المكان الصحيح',
            'حبك يملأ قلبي ويضيء حياتي',
            'أنت شريك دربي ورفيق روحي',
            'معك تعلمت معنى الحب الحقيقي',
            'أنت الهدية التي منحني الله إياها',
            'كل لحظة معك هي ذكرى جميلة',
            'أنت من يفهمني بدون كلام',
            'معك أشعر أني أقوى نسخة من نفسي',
            'أنت الأمان والسكينة في حياتي',
            'حبك يعطيني القوة لمواجهة كل شيء',
            'أنت أجمل قرار اتخذته في حياتي',
            'معك الأيام الصعبة تصبح أسهل',
            'أنت الشخص الذي أريد أن أشيخ معه',
            'حبك هو أعظم نعمة في حياتي',
            'أنت من يجعل كل يوم عادي يوماً مميزاً',
            'معك بنيت أجمل الذكريات',
            'أنت السند الذي أحتاجه دائماً',
            'حبك علمني معنى العطاء الحقيقي',
            'أنت من يضع ابتسامة على وجهي دائماً',
            'معك أشعر أني في بيتي الحقيقي',
            'أنت الشخص الذي أشاركه كل شيء',
            'حبك يملأ حياتي بالسعادة',
            'أنت من أختاره قلبي قبل عقلي',
            'معك أشعر بالاكتمال',
            'أنت أجمل هدية من الله',
            'أحبك اليوم أكثر من الأمس وأقل من الغد ❤️'
        ]
    },

    friend: {
        name: 'صديقي/صديقتي العزيز/ة',
        getOpeningMessage: (count) => `إلى صديقي/صديقتي الغالي/ة على قلبي. رمضان كريم، وكل عام وأنت بخير. ${count} رسالة صداقة من القلب`,
        messages: [
            'صديقي، أنت الأخ/الأخت الذي لم تلده أمي',
            'وجودك في حياتي نعمة أحمد الله عليها',
            'أنت من يفهمني دون أن أتكلم',
            'صداقتك هي كنز أحافظ عليه',
            'أنت السند في الأوقات الصعبة',
            'معك الضحك أحلى والحياة أجمل',
            'أنت الصديق الحقيقي الذي يبقى',
            'شكراً لكل لحظة وقفت فيها بجانبي',
            'أنت من يشاركني الفرح والحزن',
            'صداقتك علمتني معنى الوفاء',
            'أنت الشخص الذي أثق به بعيني مغمضة',
            'معك الذكريات دائماً جميلة',
            'أنت من يضحكني في أصعب الأوقات',
            'صديقي، أنت جزء لا يتجزأ من حياتي',
            'أنت من يحتفل بنجاحاتي كأنها نجاحاته',
            'معك أشعر أني لست وحدي أبداً',
            'أنت الصديق الذي يقول الحقيقة دائماً',
            'صداقتك هي من أجمل الأشياء في حياتي',
            'أنت من يعرف كل أسراري ويحتفظ بها',
            'معك الوقت يمر بسرعة دون أن نشعر',
            'أنت الأخ/الأخت الذي اخترته بنفسي',
            'صداقتك تعطيني القوة والثقة',
            'أنت من يشجعني على تحقيق أحلامي',
            'معك أشعر أني يمكن أن أكون نفسي',
            'أنت الصديق الذي يبقى مهما بعدت المسافات',
            'صداقتك علمتني معنى الإخلاص',
            'أنت من يقبلني بكل عيوبي ومميزاتي',
            'معك الحياة أكثر متعة ومعنى',
            'أنت الصديق الذي أتمنى أن يبقى للأبد',
            'شكراً لكونك هذا الصديق الرائع ❤️'
        ]
    },

    sibling: {
        name: 'أخي/أختي العزيز/ة',
        getOpeningMessage: (count) => `إلى أخي/أختي الغالي/ة على قلبي. رمضان كريم، وكل عام وأنت بخير. ${count} رسالة أخوية من القلب`,
        messages: [
            'أخي/أختي، أنت شريك طفولتي وذكرياتي',
            'معك كبرت وتعلمت معنى الأخوة الحقيقية',
            'أنت من يفهمني لأننا من نفس البيت',
            'شكراً لكل لحظة لعب وضحك معك',
            'أنت السند الذي لا يتزعزع',
            'معك الحياة أجمل والأيام أحلى',
            'أنت الصديق الأول والأخير',
            'شكراً لكل مرة دافعت فيها عني',
            'أنت من يشاركني كل شيء',
            'معك الذكريات دائماً جميلة ومضحكة',
            'أنت من يعرف كل تفاصيل حياتي',
            'شكراً لكونك الأخ/الأخت الرائع/ة',
            'أنت من يحتفل معي بكل نجاح صغير',
            'معك أشعر بالأمان والراحة',
            'أنت الرفيق في الطفولة والشباب',
            'شكراً لكل نصيحة أعطيتني إياها',
            'أنت من يقف بجانبي دائماً',
            'معك تعلمت معنى التضحية والعطاء',
            'أنت جزء من هويتي وكياني',
            'شكراً لكل خناقاتنا التي تنتهي بالصلح',
            'أنت من يفهم عائلتنا كما أفهمها',
            'معك الحياة مليئة بالذكريات الجميلة',
            'أنت الشخص الذي أثق به بعيني مغمضة',
            'شكراً لكونك أخي/أختي',
            'أنت من يشاركني تاريخنا وحاضرنا',
            'معك أشعر أني لست وحيداً أبداً',
            'أنت الرابط الذي يجمع العائلة',
            'شكراً لكل لحظة دعم وتشجيع',
            'أنت أفضل أخ/أخت يمكن أن أتمناه',
            'أحبك وأدعو الله أن يحفظك دائماً ❤️'
        ]
    }
};

export const getTemplatesByRelationship = (relationship) => {
    return messageTemplates[relationship] || null;
};

export const applyTemplate = (relationship, gift) => {
    const template = getTemplatesByRelationship(relationship);
    if (!template) return gift;

    const maxLanterns = gift.planType === 'free' ? 5 : gift.planType === 'basic' ? 15 : 30;

    const updatedLanterns = gift.lanterns.map((lantern, index) => {
        if (index < maxLanterns && template.messages[index]) {
            return {
                ...lantern,
                message: template.messages[index]
            };
        }
        return lantern;
    });

    return {
        ...gift,
        openingMessage: template.getOpeningMessage(maxLanterns),
        lanterns: updatedLanterns
    };
};